import Vue from 'vue'
import Router from 'vue-router'
import Login from './views/Login.vue'
import Services from './views/Services.vue'
import Notfound from './views/P404.vue'

/**
 *   Loading JQuery
 */
const $ = require('jquery')
window.$ = $

Vue.use(Router)

export default new Router({
    mode: 'hash',
    routes: [
        {
            path: '/',
            name: 'login',
            component: Login
        },
        {
            path: '/servicepage',
            name: 'servicepage',
            component: Services
        },
        {
            path: '*',
            name: 'P404',
            component: Notfound
        }
    ]
})